module.exports = __webpack_public_path__ + "img/selfie.ac418897.png";